// extracted by mini-css-extract-plugin
module.exports = {"primaryBtnTour":"ComposerTour_primaryBtnTour__3Xt4h","secondaryBtnTour":"ComposerTour_secondaryBtnTour__14FQd"};